export default function parseDepositLabels(type, useMonths = false) {
  const periodLabel = useMonths ? "Months" : "Weeks";
  //used to parse schedule value to label value
  switch (type) {
    case "deposit_week":
      return `Deposit (No. of ${periodLabel})`;
    case "security_deposit_week":
      return `Security Deposit (No. of ${periodLabel})`;
    case "apply_hk_rules":
      return "Apply HK rules";
    default:
      return "";
  }
}
